<template>
  <div>
    <v-card
        class="rounded-lg white" flat
    >
      <v-card-title class=" mr-3 mt-3 secondary--text">
        <v-img class="ml-2" src="/img/icons/high_amount.svg" max-width="25"></v-img>
        بیشترین مانده حساب اشخاص
        <v-spacer></v-spacer>
      </v-card-title>
      <v-tabs class="rounded-lg white--text" v-model="openTab" background-color="secondary" active-class="primary" color="#FF8700">
        <v-tab class="white--text mr-5">
          <span >خریدار</span>
        </v-tab>
        <v-tab class="white--text">
          <span>فروشنده</span>
        </v-tab>
      </v-tabs>
      <v-simple-table class="mt-5 mr-2 ml-2 rounded-b-lg">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center">
              ردیف
            </th>
            <th class="text-center">
              نام حساب
            </th>
            <th class="text-center">
              کد حساب
            </th>
            <th class="text-center">
              مانده
            </th>
            <th class="text-center">
              گردش حساب
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items">
            <td class="text-center">{{ index + 1 }}</td>
            <td class="text-center">{{ item.account_name }}</td>
            <td class="text-center">{{ item.account_code }}</td>
            <td class="text-center">{{ item.remain | toMoney }}</td>
            <td class="text-center">
              <open-ledger-btn :query="getSubAccountLedgerQuery(item)"/>
            </td>
          </tr>

          </tbody>
        </template>
      </v-simple-table>

    </v-card>

  </div>

</template>

<script>
import OpenLedgerBtn from "@/components/btns/OpenLedgerBtn";
export default {
  name: "HighestBalanceAmountTable",
  components: {
    OpenLedgerBtn
  },
  props: {
    id: {},
  },
  data() {
    return {
      openTab: 0,
      received: null,
      paid: null,
    };
  },
  mounted() {
    this.getData()
  },
  computed: {
    items(){
      if (this.openTab == 0){
        return this.received
      } else {
        return this.paid
      }
    }
  },
  updated() {
  },
  methods: {
    getSubAccountLedgerQuery(item) {
      return {
        "ledger.account": item.account_id,
        "ledger.level": `level3`,
      };
    },

    getData(){
      this.request({
        url: this.endpoint('reports/mostBalanceAccounts'),
        method: "get",
        success: data => {
          this.received = data.received
          this.paid = data.paid
        },
      })
    },

  }

}
</script>

<style scoped lang="scss"></style>

